import { headingMd } from '@insify/design-system/typography';
import { useBreakpoint } from '@insify/react-hooks';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

import { SendLinkForm } from '../../../components/SendLinkForm';
import { Paragraph } from '../../../components/Typography/Typography';
import { AuthLayout } from '../../layouts/AuthLayout';

import * as styles from './LoginPage.module.css';

const LoginPage: React.FC = () => {
  const { t } = useTranslation('common');
  const isMobile = !useBreakpoint('(min-width: 960px)');

  return (
    <AuthLayout>
      <div>
        <h1 className={clsx(headingMd, styles.title)}>{t('login_header')}</h1>
        <Paragraph className={styles.text} density='condensed'>
          {t(isMobile ? 'login_link_explanation_mobile' : 'login_link_explanation_web')}
        </Paragraph>
      </div>
      <SendLinkForm />
    </AuthLayout>
  );
};

export { LoginPage };
